import { Clock, LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import { useAuth } from '@/lib/auth/useAuth';
import { authApi } from './api';
import { useT } from '@/lib/i18n/useT';

export function PendingAccessPage() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const t = useT();
  return (
    <div className="flex min-h-screen items-center justify-center px-6 py-12">
      <div className="w-full max-w-md text-center">
        <div className="mx-auto mb-6 grid h-16 w-16 place-items-center rounded-full bg-[rgb(245_158_11/0.1)] text-[var(--color-warn)]">
          <Clock className="h-7 w-7" />
        </div>
        <h1 className="text-2xl font-bold">{t('pendingAccess.title')}</h1>
        <p className="mt-2 text-sm text-[var(--color-fg-muted)]">
          {t('pendingAccess.body')}
        </p>
        <p className="mt-6 text-xs text-[var(--color-fg-subtle)]">
          {t('pendingAccess.signedInAs')}{' '}
          <span className="text-[var(--color-fg-primary)]">{user?.email}</span>
        </p>
        <Button
          variant="ghost"
          className="mt-4"
          leftIcon={<LogOut className="h-4 w-4" />}
          onClick={async () => {
            await authApi.logout().catch(() => undefined);
            logout();
            navigate('/login');
          }}
        >
          {t('common.signOut')}
        </Button>
      </div>
    </div>
  );
}
